export const REMAINING_BAND_COLORS = {
    overdue: { bg: 'rgba(220, 53, 69, 0.8)', border: 'rgba(220, 53, 69, 1)' },
    critical: { bg: 'rgba(255, 152, 0, 0.8)', border: 'rgba(255, 152, 0, 1)' },
    watch: { bg: 'rgba(255, 193, 7, 0.8)', border: 'rgba(255, 193, 7, 1)' },
    remaining: { bg: 'rgba(4, 106, 56, 0.8)', border: 'rgba(4, 106, 56, 1)' },
};

export const REMAINING_BAND_LABELS = {
    overdue: 'Overdue',
    critical: '≤ 50 hrs',
    watch: '≤ 200 hrs',
    remaining: '> 200 hrs',
};

export const REMAINING_BAND_ORDER = ['overdue', 'critical', 'watch', 'remaining'];

export function getRemainingBand(remaining) {
    if (remaining < 0) return 'overdue';
    if (remaining <= 50) return 'critical';
    if (remaining <= 200) return 'watch';
    return 'remaining';
}

export function uniqueChartLabel(buno, posCd, serno, used) {
    const base = posCd ? `${buno} (${posCd})` : String(buno);
    let label = base;
    if (used.has(label) && serno) {
        label = `${base} #${serno}`;
    }
    let unique = label;
    let n = 2;
    while (used.has(unique)) {
        unique = `${label} (${n})`;
        n += 1;
    }
    used.add(unique);
    return unique;
}

export function processHighTimeComponentData(rows) {
    const usedLabels = new Set();
    const items = (rows || [])
        .filter(r => r.usg_remng_qty != null && r.buno)
        .map(r => {
            const remaining = parseFloat(r.usg_remng_qty) || 0;
            const band = getRemainingBand(remaining);
            const colors = REMAINING_BAND_COLORS[band];
            const buno = String(r.buno).trim();
            return {
                id: r.id,
                buno,
                modex: r.modex || '',
                siteName: r.site_name || '',
                nomen: r.nomen || '',
                crdNomen: r.crd_nomen || '',
                pn: r.pn || '',
                posCd: r.pos_cd || '',
                serno: r.serno || '',
                remaining,
                schdExpndtr: r.schd_expndtr,
                tsn: r.tsn,
                tso: r.tso,
                band,
                label: uniqueChartLabel(buno, r.pos_cd, r.serno, usedLabels),
                backgroundColor: colors.bg,
                borderColor: colors.border,
            };
        });

    items.sort((a, b) => a.remaining - b.remaining);
    return buildHighTimeWaterfallChart(items);
}

export function buildHighTimeWaterfallChart(items) {
    const bandSet = new Set(items.map(i => i.band));
    const bandColors = {};
    REMAINING_BAND_ORDER.forEach(band => {
        if (bandSet.has(band)) {
            bandColors[band] = REMAINING_BAND_COLORS[band];
        }
    });

    return {
        labels: items.map(i => i.label),
        datasets: [{
            label: 'Usage Remaining',
            data: items.map(i => i.remaining),
            backgroundColor: items.map(i => i.backgroundColor),
            borderColor: items.map(i => i.borderColor),
            borderWidth: 2,
        }],
        items,
        bandColors,
    };
}

export function filterComponents(components, search) {
    const q = (search || '').trim().toLowerCase();
    if (!q) return components || [];
    return (components || []).filter(c => {
        const nomen = (c.nomen || '').toLowerCase();
        if (nomen.includes(q)) return true;
        const familyId = (c.family_id || '').toLowerCase();
        if (familyId.includes(q)) return true;
        const pns = c.pns || (c.pn ? [c.pn] : []);
        return pns.some(pn => String(pn).toLowerCase().includes(q));
    });
}
